import {
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
} from "reactstrap";
import { P } from "AbstractElements";
import Moment from "moment";
import "moment/locale/id";

const SessionDetailModal = ({
	isOpen,
	onClose,
	detail,
	isLoading,
	error,
}) => {
	return (
		<Modal isOpen={isOpen} toggle={onClose} size="lg" centered scrollable>
			<ModalHeader toggle={onClose}>
				Detail Session Progress
				{detail?.memberName ? ` — ${detail.memberName}` : ""}
			</ModalHeader>
			<ModalBody>
				{isLoading && (
					<div className="text-center py-4">
						<Spinner color="primary" />
					</div>
				)}

				{error && !isLoading && (
					<div className="rounded-3 border border-danger-subtle bg-danger-subtle p-3">
						<P className="mb-0 text-danger">
							{typeof error === "string" ? error : "Gagal memuat detail sesi."}
						</P>
					</div>
				)}

				{detail && !isLoading && (
					<>
						<div className="rounded-3 border bg-light p-3 mb-3">
							<div className="row g-2">
								<div className="col-md-6">
									<div className="small text-muted mb-1">Tentor</div>
									<div className="fw-semibold text-dark">{detail.tentorName}</div>
								</div>
								<div className="col-md-6">
									<div className="small text-muted mb-1">Siswa / Member</div>
									<div className="fw-semibold text-dark">{detail.memberName}</div>
								</div>
								<div className="col-md-6">
									<div className="small text-muted mb-1">Checkout</div>
									<div className="text-dark">
										{detail.checkoutAt
											? Moment(detail.checkoutAt)
													.locale("id")
													.format("dddd, DD MMM YYYY HH:mm")
											: "-"}
									</div>
								</div>
								{detail.averageScore != null && (
									<div className="col-md-6">
										<div className="small text-muted mb-1">Rata-rata</div>
										<div className="fw-semibold text-dark">
											{Number(detail.averageScore).toFixed(1)} / 5
										</div>
									</div>
								)}
							</div>
						</div>

						{detail.answers?.length > 0 && (
							<div className="mb-4">
								<h6 className="fw-semibold mb-3">Jawaban Progress (Q1–Q10)</h6>
								<div className="d-flex flex-column gap-2">
									{detail.answers.map((item) => (
										<div
											key={item.code}
											className="rounded-3 border p-3 bg-white d-flex flex-column flex-md-row gap-1 gap-md-3"
										>
											<div className="flex-grow-1 small text-muted">{item.title}</div>
											<div className="fw-semibold text-dark text-md-end" style={{ minWidth: 80 }}>
												{item.displayAnswer}
											</div>
										</div>
									))}
								</div>
							</div>
						)}

						<div>
							<h6 className="fw-semibold mb-2">Catatan</h6>
							<div className="rounded-3 border p-3 bg-white text-dark" style={{ whiteSpace: "pre-wrap" }}>
								{detail.note?.trim() ? detail.note : "Tidak ada catatan."}
							</div>
						</div>
					</>
				)}
			</ModalBody>
		</Modal>
	);
};

export default SessionDetailModal;
